import axios from 'axios'
import baseURL from '@/config/common'

const service = axios.create({
  baseURL: baseURL.url,
  timeout: 10000
})

service.interceptors.request.use(config => {
  return config
}, err => {
  Promise.reject(err)
})

service.interceptors.response.use(res => {
  if (res.data.rcode === 0) {
    return res.data
  } else {
    return res.data
  }
}, err => {
  // console.log(err.response.data.message)
  return Promise.reject(err.response.data)
})

export default service



// WEBPACK FOOTER //
// ./src/libs/request.js